import enTranslations from './en.json';

/**
 * i18next namespace key used by the package's Sidekick chrome.
 * Consumers register `sidekickEnTranslations` under this namespace in
 * their `i18next.init({ resources })` payload.
 */
export const SIDEKICK_TRANSLATION_NAMESPACE = 'sidekick';

/**
 * English translation bundle for the Sidekick package. Shape:
 * `{ entry: { openAriaLabel, suggestions }, panel: { title, closeAriaLabel,
 * newConversationAriaLabel, placeholder }, chat: { emptyState,
 * thinking, input, askSomethingElse, messages } }`.
 *
 * `panel.placeholder` and `chat.emptyState.copy` carry the same
 * English string by design — `panel.placeholder` is kept for
 * back-compat with the existing `<PanelPlaceholder />` component
 * shipped in PR-2; `chat.emptyState.copy` is the canonical key for
 * the panel zero-state copy going forward.
 *
 * Suggestion chips resolve every `translationKey` against this
 * namespace. Service-driven chips carry their own `label` instead.
 */
export const sidekickEnTranslations = enTranslations;
export type SidekickTranslationBundle = typeof enTranslations;
